<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "../../../components/widgets/loader";
import Forms from "../../../mixins/Forms";
import Tickets from "../../../mixins/Tickets";
import Dates from "../../../mixins/Dates";
import TicketCard from "../../../components/tickets/TicketCard";

let _ = require('lodash');

import axios from 'axios';
import SortByFilters from "./index/SortByFilters";
import AllIncompleteTasks from '../../../components/tickets/AllIncompleteTasks.vue';

/**
 * View ticket component
 */
export default {
  page: {
    title: "All Tickets",
    meta: [{ name: "description", content: appConfig.description }]
  },
  mixins: [Forms, Tickets, Dates],
  components: { SortByFilters, Layout, PageHeader, Loader, TicketCard, AllIncompleteTasks },
  data() {
    return {
      title: "All Tickets",
      items: [
        {
          text: "Tickets",
          href: "#"
        },
        {
          text: "All Tickets",
          active: true
        }
      ],

      serverErrors: [],
      isLoading: false,
      tickets: null,
      isLoadingAgents: false,
      agents: [],

      isLoadingTravelConsultantNames: false,
      travelConsultantNames: [],

      isLoadingTagTemplates: false,
      tagTemplates: [],

      searchQueryIsDirty: false,
      searchQuery: '',
      filters: {
        sort_by: 'created_at',
        sort_order: 'DESC',
        results_per_page: 30,
        status: [],
        priority: [],
        difficulty: [],
        only_show_my_tickets: false,
        hide_closed_tickets: false,
        agent_id: [],
        travel_consultant_names: [],
        tags: [],
        source: [],
        layout: 'cards' // table or cards
      }
    };
  },
  computed: {
    ticketResults() {
      if (this.tickets) {
        return this.tickets.data;
      }
      return [];
    }
  },
  methods: {
    determineSearchParams(page) {
      let params = {
        q: this.searchQuery,
        page: page,
        results_per_page: this.filters.results_per_page,
        sort_by: this.filters.sort_by,
        sort_order: this.filters.sort_order
      };

      if (this.filters.status.length) {
        params['status'] = this.filters.status;
      }

      if (this.filters.priority.length) {
        params['priority'] = this.filters.priority;
      }

      if (this.filters.difficulty.length) {
        params['difficulty'] = this.filters.difficulty;
      }

      if (this.filters.only_show_my_tickets === true) {
        params['only_show_my_tickets'] = this.filters.only_show_my_tickets;
      } else if (this.filters.agent_id.length) {
        params['agent_id'] = this.filters.agent_id;
      }

      if (this.filters.tags && this.filters.tags.length) {
        params['tags'] = this.filters.tags;
      }

      if (this.filters.travel_consultant_names && this.filters.travel_consultant_names.length) {
        params['travel_consultant_names'] = this.filters.travel_consultant_names;
      }

      if (this.filters.hide_closed_tickets) {
        params['not_closed'] = true;
      }

      if (this.filters.source && this.filters.source.length) {
        params['source'] = this.filters.source;
      }

      return params;
    },

    loadTickets: _.debounce(function (page = 1) {
      let vm = this;
      vm.serverErrors = [];
      vm.isLoading = true;
      axios.post(API_BASE + '/tickets/search', vm.determineSearchParams(page)).then(r => {
        vm.tickets = r.data;
        vm.isLoading = false;
        vm.searchQueryIsDirty = false;
      }).catch(e => {
        console.log(e);
        vm.isLoading = false;
        vm.setErrors(e);
      });
    }),

    loadAgents() {
      let vm = this;
      vm.serverErrors = [];
      vm.isLoadingAgents = true;

      axios.get(API_BASE + '/users').then(r => {
        vm.isLoadingAgents = false;
        vm.agents = r.data;
      }).catch(e => {
        console.log(e);
        vm.isLoadingAgents = false;
        vm.setErrors(e);
      });
    },

    loadTravelConsultantNames() {
      let vm = this;
      vm.isLoadingTravelConsultantNames = true;
      axios.get(API_BASE + '/travel-consultants/names/cached').then(r => {
        vm.isLoadingTravelConsultantNames = false;
        vm.travelConsultantNames = _.without(r.data, null);
      }).catch(e => {
        console.log(e);
        vm.isLoadingTravelConsultantNames = false;
        vm.travelConsultantNames = [];
      });
    },

    loadTagTemplates() {
      let vm = this;
      vm.isLoadingTagTemplates = true;
      axios.get(API_BASE + '/tag-templates/cached').then(r => {
        vm.isLoadingTagTemplates = false;
        vm.tagTemplates = r.data;
      }).catch(e => {
        console.log(e);
        vm.isLoadingTagTemplates = false;
        vm.tagTemplates = [];
      });
    },

    setup() {
      // Load filters from local storage if exists
      let filters = localStorage.getItem('tickets_filters');
      if (filters) {
        this.filters = JSON.parse(filters);
        // if not set, set source to []
        if (!this.filters.source) {
          this.filters.source = [];
        }
      }

      this.loadAgents();
      this.loadTagTemplates();
      this.loadTravelConsultantNames();
      if (this.$route.query && this.$route.query['q']) {
        this.searchQuery = this.$route.query['q'];
      }
      this.loadTickets();
    }
  },
  watch: {
    '$route': 'setup',
    searchQuery: function () {
      this.searchQueryIsDirty = true;
      this.loadTickets();
    },
    filters: {
      handler: function () {
        this.loadTickets();

        // Save to local storage
        localStorage.setItem('tickets_filters', JSON.stringify(this.filters));
      },
      deep: true
    }
  },
  created() {
    this.setup();
  }
};
</script>

<template>
  <Layout>
    <all-incomplete-tasks></all-incomplete-tasks>

    <PageHeader :title="title" :items="items" />
    <errors :error-list="serverErrors"></errors>

    <div class="row">
      <div class="col-lg-9">
        <!-- Table view -->
        <div v-if="filters.layout === 'table'" class="card">
          <div class="card-body">
            <!-- Filters -->
            <div class="row mb-3">
              <div class="col-sm-4">
                <div class="search-box mr-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input v-model="searchQuery" type="text" class="form-control" placeholder="Search..." />
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>
            </div>
            <!-- / Filters -->

            <div v-if="isLoading || searchQueryIsDirty" class="text-center">
              <b-spinner class="m-2" variant="itg-dark" role="status"></b-spinner>
            </div>

            <div v-if="!(isLoading || searchQueryIsDirty)" class="table-responsive mb-0">
              <table class="table mb-0 table-centered">
                <thead class="thead-light">
                  <tr>
                    <th>#</th>
                    <th>Subject</th>
                    <th>Status</th>
                    <th>Priority</th>
                    <th>Difficulty</th>
                    <th>Time Open</th>
                    <th>Agent</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="ticket in ticketResults" :key="ticket.id">
                    <th scope="row">{{ ticket.id }}</th>
                    <td>{{ ticket.subject }}</td>
                    <td>{{ getHumanReadableTicketStatus(ticket.status) }}</td>
                    <td>{{ getHumanReadableTicketPriority(ticket.priority) }}</td>
                    <td>{{ ticket.difficulty }}</td>
                    <td>{{ displayTimeOpen(ticket.received_at) }}</td>
                    <td>{{ ticket.agent ? ticket.agent.name : '-' }}</td>
                    <td class="text-right">
                      <!-- Button trigger modal -->
                      <button type="button" class="btn btn-itg btn-itg btn-sm"
                        @click="$router.push('/tickets/' + ticket.id)">
                        View
                      </button>
                    </td>
                  </tr>
                  <tr v-if="ticketResults.length === 0">
                    <th scope="row" colspan="7">
                      <span class="text-danger">No results</span>
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
        <!-- / Table view -->

        <!-- Card view -->
        <div v-if="filters.layout === 'cards'">
          <!-- Filters -->
          <div class="row mb-3">
            <div class="col-sm-4">
              <div class="search-box mr-2 mb-2 d-inline-block">
                <div class="position-relative">
                  <input v-model="searchQuery" type="text" class="form-control" placeholder="Search..." />
                  <i class="bx bx-search-alt search-icon"></i>
                </div>
              </div>
            </div>
            <div class="col-sm-8 text-right">
              <sort-by-filters :filters="filters"></sort-by-filters>
            </div>
          </div>
          <!-- / Filters -->

          <!-- Is Loading -->
          <div v-if="isLoading || searchQueryIsDirty" class="card">
            <div class="card-body text-center">
              <b-spinner class="m-2" variant="itg-dark" role="status"></b-spinner>
            </div>
          </div>
          <!-- / Is Loading -->

          <!-- Cards -->
          <div v-if="!(isLoading || searchQueryIsDirty)" class="card-results-wrapper">
            <ticket-card v-for="ticket in ticketResults" :key="ticket.id" :ticket="ticket"></ticket-card>
            <div class="card" v-if="ticketResults.length === 0">
              <div class="card-body">
                <b class="text-danger">No results</b>
              </div>
            </div>
          </div>
          <!--- / Cards -->
        </div>
        <!-- / Card view -->

        <pagination v-if="!(isLoading || searchQueryIsDirty) && tickets" :data="tickets" :limit="8"
          @pagination-change-page="loadTickets"></pagination>
      </div>
      <div class="col-lg-3">
        <div class="card">
          <div class="card-body p-4">
            <!-- Results per page -->
            <div class="form-group mb-3">
              <label for="results_per_page">Results To Show</label>
              <v-select v-model="filters.results_per_page" :clearable="false"
                :options="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"></v-select>
            </div>
            <!-- / Results per page -->

            <!-- Status -->
            <div class="form-group mb-3">
              <label for="status">Status</label>
              <v-select multiple v-model="filters.status" label="label" placeholder="Show all"
                :reduce="option => option.value" :options="ticketStatusDropdownOptions"></v-select>
            </div>
            <!-- / Status -->

            <!-- Priority -->
            <div class="form-group mb-3">
              <label for="priority">Priority</label>
              <v-select multiple v-model="filters.priority" label="label" placeholder="Show all"
                :reduce="option => option.value" :options="ticketPriorityDropdownOptions"></v-select>
            </div>
            <!-- / Priority -->

            <!-- Difficulty -->
            <div class="form-group mb-3">
              <label for="difficulty">Difficulty</label>
              <v-select multiple v-model="filters.difficulty" placeholder="Show all"
                :reduce="difficulty => difficulty.value" :options="ticketDifficultyDropdownOptions"></v-select>
            </div>
            <!-- / Priority -->

            <!-- Hide closed tickets -->
            <div class="form-group mb-3">
              <label for="hide_closed_tickets">Hide Closed Tickets?</label>
              <v-select v-model="filters.hide_closed_tickets" label="label" :reduce="option => option.value"
                :clearable="false" :options="[{ value: true, label: 'Yes' }, { value: false, label: 'No' }]"></v-select>
            </div>
            <!-- / Hide closed tickets -->

            <!-- Only show my tickets -->
            <div class="form-group mb-3">
              <label for="only_show_my_tickets">Only Show My Tickets?</label>
              <v-select v-model="filters.only_show_my_tickets" label="label" :reduce="option => option.value"
                :clearable="false" :options="[{ value: true, label: 'Yes' }, { value: false, label: 'No' }]"></v-select>
            </div>
            <!-- / Only show my tickets -->

            <!-- Agent -->
            <div class="form-group mb-3" v-if="!filters.only_show_my_tickets">
              <label for="agent_id">Agent</label>
              <v-select multiple v-model="filters.agent_id" placeholder="Show all" label="name"
                :disabled="isLoadingAgents" :reduce="agent => agent.id" :options="agents"></v-select>
            </div>
            <!-- / Agent -->

            <!-- Travel Consultant -->
            <div class="form-group mb-3">
              <label for="travel_consultant">Travel Consultant</label>
              <v-select multiple v-model="filters.travel_consultant_names" placeholder="Show all" label="name"
                :disabled="isLoadingTravelConsultantNames" :options="travelConsultantNames"></v-select>
            </div>
            <!-- / Travel Consultant -->

            <!-- Tags -->
            <div class="form-group mb-3">
              <label for="tags">Tags</label>
              <v-select multiple v-model="filters.tags" placeholder="Show all" label="name"
                :disabled="isLoadingTagTemplates" :reduce="tag => tag.name" :options="tagTemplates"></v-select>
            </div>
            <!-- / Tags -->

            <!-- Source -->
            <div class="form-group mb-3">
              <label for="source">Source</label>
              <v-select multiple v-model="filters.source" label="label" placeholder="Show all"
                :reduce="option => option.value" 
                :options="ticketSourceDropdownOptions"></v-select>
            </div>
            <!-- / Source -->

            <!-- Layout -->
            <div class="form-group mb-3">
              <label for="layout">Layout</label>
              <v-select v-model="filters.layout" label="label" :reduce="option => option.value" :clearable="false"
                :options="[{ value: 'cards', label: 'Cards' }, { value: 'table', label: 'Table' }]"></v-select>
            </div>
            <!-- / Layout -->
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<style scoped>
.main-content {
  overflow: visible;
}
</style>
